module.exports = __webpack_public_path__ + "img/truck-sm-orange.a72c98b3.svg";